import type { HTMLAttributes, ReactNode } from "react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";
import { css } from "@emotion/react";
import { TextV2 } from "src/components/TextV2/TextV2.tsx";

type DefinitionListProps = {
  renderLabel?: (label: string) => ReactNode;
  renderValue?: (value: string) => ReactNode;
  definitions: {
    label: string;
    value: string;
  }[];
} & HTMLAttributes<HTMLDListElement>;

export const DefinitionList = ({
  definitions,
  renderLabel: renderLabelProp,
  renderValue: renderValueProp,
  ...rest
}: DefinitionListProps) => {
  const defaultRenderLabel = (label: string) => {
    return <TextV2 variant={"body1"}>{label}</TextV2>;
  };
  const defaultRenderValue = (value: string) => {
    return <TextV2 variant={"body1"}>{value}</TextV2>;
  };
  const renderLabel = renderLabelProp || defaultRenderLabel;
  const renderValue = renderValueProp || defaultRenderValue;

  return (
    <dl css={styles.root} {...rest}>
      {definitions.map((definition, index) => (
        <div key={index} css={styles.item}>
          <dt>{renderLabel(definition.label)}</dt>
          <dd
            style={{
              marginLeft: 10,
            }}
          >
            {renderValue(definition.value)}
          </dd>
        </div>
      ))}
    </dl>
  );
};

const styles = {
  item: (theme: ExactTheme) => [
    css`
      padding-top: 6px;
      padding-bottom: 1px;

      line-height: 21px;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px dashed ${theme.colorsV2.grey[100]};
    `,
  ],
  root: css`
    margin: 0;
  `,
};
